// extracted by mini-css-extract-plugin
export default {"small":"FlagIcon_small__DILnR","medium":"FlagIcon_medium__Gz5zF","large":"FlagIcon_large__LsdsE"};